module.exports = __webpack_public_path__ + "img/art8.1f303073.png";